import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Alert, Snackbar } from "@mui/material";
import Loader from "../../Loader/Loader";
import { editfees, feedetail } from "../../service/Mainservice";
import { useFormik } from "formik";

const validate = (values, isInitialLoad) => {
  const errors = {};
  if (isInitialLoad) return errors;

  if (!values.tax) {
    errors.tax = "Required";
  }
  if (!values.charge) {
    errors.charge = "Required";
  }
  if (!values.deliveryBoyCommission) {
    errors.deliveryBoyCommission = "Required";
  }
  if (!values.commision) {
    errors.commision = "Required";
  }

  return errors;
};
const Feestructure = () => {
  const [loading, setloading] = useState(true);
  const [load, setload] = useState(false);
  const [data, setData] = useState([]);
  const [showdelete, setshowdelete] = useState(false);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [success, setsuccess] = useState("");
  const [err, seterror] = useState("");
  const [pagination, setpagination] = useState({ page: 1 });

  const navigate = useNavigate();

  useEffect(() => {
    getData("1");
  }, []);

  const getData = async (value) => {
    try {
      const response = await feedetail(value);
      setloading(false);
      console.log(response.data.daat);
      formik.setValues(
        {
          tax: response.data.data[0].taxAmount,
          charge: response.data.data[0].deliveryChargePerKm,
          commision: response.data.data[0].adminCut,
          pickup: response.data.data[0].pickup,
          dropoff: response.data.data[0].dropoff,
          serviceFee: response.data.data[0].serviceFee,
          deliveryBoyCommission: response.data.data[0].deliveryBoyCommission,
        },
        false
      );
    } catch (error) {
      setloading(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const formik = useFormik({
    initialValues: {
      tax: "",
      commision: "",
      charge: "",
      pickup: "",
      dropoff: "",
      serviceFee: "",
      deliveryBoyCommission: "",
    },
    validate,
    onSubmit: (values) => {
      console.log(values);
      handleAdd(values);
    },
  });

  const handleAdd = async (values) => {
    setload(true);
    try {
      const params = {
        taxAmount: values.tax,
        adminCut: values.commision,
        deliveryChargePerKm: values.charge,
        pickup: values.pickup,
        dropoff: values.dropoff,
        serviceFee: values.serviceFee,
        deliveryBoyCommission: values.deliveryBoyCommission,
      };
      const response = await editfees(params);
      setsuccess(response.data.message);
      setOpen2(true);
      setload(false);
    } catch (error) {
      seterror(error.message);
      setOpen(true);
      setload(false);
      if (error.status === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">Fee structure</h1>
          <div className="data_headdown">
            {/* <div className="searchicon">
              <SearchIcon />
              <input
                type="search"
                placeholder="Search..."
                id="search"
                // onKeyDown={handlesearch}
              />
            </div>*/}
          </div>
        </div>
        <form onSubmit={formik.handleSubmit} className="interview_form">
          <div>
            <label className="Auth_label">Tax Amount</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="tax"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.tax}
              className="Auth_input"
            />
            {formik.errors.tax ? (
              <p className="invalid">{formik.errors.tax} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Admin Commision</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="commision"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.commision}
              className="Auth_input"
            />
            {formik.errors.commision ? (
              <p className="invalid">{formik.errors.commision} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Delivery Charge(per km)</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="charge"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.charge}
              className="Auth_input"
            />
            {formik.errors.charge ? (
              <p className="invalid">{formik.errors.charge} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Pickup</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="pickup"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.pickup}
              className="Auth_input"
            />
            {formik.errors.pickup ? (
              <p className="invalid">{formik.errors.pickup} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Dropoff</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="dropoff"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.dropoff}
              className="Auth_input"
            />
            {formik.errors.dropoff ? (
              <p className="invalid">{formik.errors.dropoff} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Service Fee</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="serviceFee"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.serviceFee}
              className="Auth_input"
            />
            {formik.errors.serviceFee ? (
              <p className="invalid">{formik.errors.serviceFee} </p>
            ) : null}
          </div>
          <div>
            <label className="Auth_label">Driver Commission</label>
            <br />
            <input
              onChange={formik.handleChange}
              name="deliveryBoyCommission"
              type="number"
              minLength={1}
              maxLength={200}
              value={formik.values.deliveryBoyCommission}
              className="Auth_input"
            />
            {formik.errors.deliveryBoyCommission ? (
              <p className="invalid">{formik.errors.deliveryBoyCommission} </p>
            ) : null}
          </div>

          <div />

          <button className="term_button" type="Submit">
            {load ? "Updating..." : "Save"}
          </button>
        </form>{" "}
      </div>

      {loading && <Loader />}
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={() => setOpen(false)}
      >
        <Alert severity="error" variant="filled" sx={{ width: "70vw" }}>
          {err}
        </Alert>
      </Snackbar>
      <Snackbar
        open={open2}
        autoHideDuration={6000}
        onClose={() => setOpen2(false)}
      >
        <Alert severity="success" variant="filled" sx={{ width: "70vw" }}>
          {success}
        </Alert>
      </Snackbar>
    </>
  );
};
export default Feestructure;
